<script setup lang="ts">
import NoInputConfirmModal from '@/components/modal/NoInputConfirmModal.vue';
import type { InviteDeleteModalProps } from '@/stores/modal';
import { ref } from 'vue';

const props = defineProps<InviteDeleteModalProps>();

const isSubmitting = ref(false);

const deleteHandler = async () => {
  isSubmitting.value = true;
  try {
    await props.onConfirm(props.guestId);
  } finally {
    setTimeout(() => {
      isSubmitting.value = false;
    }, 300);
  }
};
</script>

<template>
  <NoInputConfirmModal
    title="방문자 삭제"
    message="정말로 삭제하시겠습니까?"
    modal-type="invite-delete"
    confirm-text="확인"
    cancel-text="취소"
    :is-loading="isSubmitting"
    @confirm="deleteHandler"
  />
</template>

